export const getEventTrackGA = (obj) => {

	if ((typeof obj !== 'undefined') && typeof ga !== 'undefined') {

		// let category = obj.category;
		// let action = obj.action;
		// let label = obj.label;
		const { category = 'quikr_pwa', action, label, ...rest } = obj;
		let windowNewOpen = obj.windowNewOpen;
		let windowOpen = obj.windowOpen;

		if (category !== '' && action !== '' && label !== '') {

			if (typeof ga !== 'undefined' && ga) {
				ga('quikrPWATracker.send','event', { eventCategory: category, eventAction: action, eventLabel: label, ...rest });
			}
			else {
				console.log('Google Analytics not loaded');
			}

			if (typeof gen_comscore_tag === 'function') {
				gen_comscore_tag('www.quikr.com/' + category + action);
			}
		}

		if (windowNewOpen) {
			window.open(windowNewOpen, '_blank');
		}

		if (windowOpen) {
			window.location = windowOpen;
			return false;
		}
	}

};




// WEBPACK FOOTER //
// ../q-components/helpers/ga.js